import {
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Skeleton,
  Stack,
  Switch,
  Text,
  Spinner,
} from "@chakra-ui/react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Card from "components/Card/Card";
import CardBody from "components/Card/CardBody";
import DriversTable from "components/Tables/DriversTable";
import React, { useEffect, useMemo, useState } from "react";
import { IoIosArrowDown } from "react-icons/io";
import { driversApiAction } from "stores/redux/apiSlices/driverApi/driverApiSlice";
import { DriverColumn } from "variables/columnsData";
import DriverData from "variables/DriverData.json";

function DriversList({ handleAddClient, handleEdit, handleDelete }) {
  const [isActive, setIsActive] = useState(undefined);

  const filters = useMemo(() => {
    const base = { role: "DRIVER", limit: 100 };
    if (isActive === true) base.isActive = true;
    else if (isActive === false) base.isActive = false;
    return base;
  }, [isActive]);

  const {
    data,
    error,
    isLoading,
    refetch,
  } = driversApiAction.getDriversListApi(filters, {
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    refetch();
  }, [refetch]);

  const driverListData = data?.data?.users;

  return (
    <Flex direction="column" pt={{ sm: "125px", md: "75px" }}>
      <Flex
        direction={{ sm: "column", md: "row" }}
        justify="space-between"
        align="center"
        w="100%"
        mb="24px"
      >
        <Button
          mt={0}
          bg="linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)"
          _hover={{
            bg: "linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)",
          }}
          _disabled={{
            _hover: {
              bg: "linear-gradient(81.62deg, #313860 2.25%, #151928 79.87%)",
            },
          }}
          color="#fff"
          minW="125px"
          h="35px"
          fontSize="xs"
          fontWeight="bold"
          mb={{ sm: "12px", md: "0px" }}
          onClick={handleAddClient}
        >
          ΠΡΟΣΘΗΚΗ ΟΔΗΓΟΥ
        </Button>
        <Stack
          direction="row"
          spacing="10px"
          alignSelf={{ sm: "flex-start", lg: "auto" }}
        >
          <Menu zIndex={100}>
            <MenuButton
              as={Button}
              rightIcon={<IoIosArrowDown />}
              color="gray.700"
              w="125px"
              h="35px"
              bg="#fff"
              fontSize="xs"
            >
              ΦΙΛΤΡΑ
            </MenuButton>
            <MenuList zIndex={100}>
              <MenuItem
                closeOnSelect={false}
                onClick={() => {
                  setIsActive((prev) => (prev === true ? undefined : true));
                }}
              >
                <Flex justify="space-between" align="center" w="100%">
                  <Text color="gray.500">Ενεργό</Text>
                  <Switch
                    size="sm"
                    isChecked={isActive === true}
                    onClick={(e) => e.stopPropagation()}
                    onChange={() =>
                      setIsActive((prev) => (prev === true ? undefined : true))
                    }
                  />
                </Flex>
              </MenuItem>

              <MenuItem
                closeOnSelect={false}
                onClick={() => {
                  setIsActive((prev) => (prev === false ? undefined : false));
                }}
              >
                <Flex justify="space-between" align="center" w="100%">
                  <Text color="gray.500">Ανενεργό</Text>
                  <Switch
                    size="sm"
                    isChecked={isActive === false}
                    onClick={(e) => e.stopPropagation()}
                    onChange={() =>
                      setIsActive((prev) =>
                        prev === false ? undefined : false
                      )
                    }
                  />
                </Flex>
              </MenuItem>

              <MenuDivider />
              <MenuItem color="red.300" onClick={() => setIsActive(undefined)}>
               Εκκαθάριση
              </MenuItem>
            </MenuList>
          </Menu>
          <Button
            variant="no-hover"
            bg="#fff"
            w="125px"
            h="35px"
            color="gray.700"
            fontSize="xs"
            fontWeight="bold"
            onClick={() => {
              if (!driverListData || driverListData.length === 0) {
                console.warn("No data available to export.");
                return;
              }

              const worksheet = XLSX.utils.json_to_sheet(driverListData);
              const workbook = XLSX.utils.book_new();
              XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");
              const excelBuffer = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array",
              });

              const blob = new Blob([excelBuffer], {
                type:
                  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });

              const currentDate = new Date().toISOString().split("T")[0];
              saveAs(blob, `driverListData_${currentDate}.xlsx`);
            }}
          >
            ΕΞΑΓΩΓΗ
          </Button>
        </Stack>
      </Flex>
      <Card px="0px">
        <CardBody>
          {isLoading ? (
            <Flex
              justify="center"
              align="center"
              direction="column"
              minH="300px"
              w="100%"
            >
              <Spinner size="xl" thickness="4px" speed="0.65s" color="blue.500" />
              <Text mt={4} fontSize="md" color="gray.600">
                Loading drivers...
              </Text>
            </Flex>
          ) : (
            <DriversTable
              tableData={Array.isArray(driverListData) ? driverListData : []}
              onEdit={handleEdit}
              onDelete={handleDelete}
            />
          )}
        </CardBody>
      </Card>
    </Flex>
  );
}

export default DriversList;
